import React from 'react'

interface InputErrorMessageProps {
    children: string | undefined
}
export const InputErrorMessage: React.FC<InputErrorMessageProps> = (props) => {
  return (
    <span className="mensagem-de-erro-input"> {props.children} </span>
  )
}
